module.exports = __webpack_public_path__ + "14a4a425.svg";